import React, { Fragment } from "react";
import {
  IconNameEnum,
  useModuleBEM,
  useUiStyles,
} from "@b2bportal/core-themes";
import { CoreUiComponents } from "@b2bportal/core-types";
import * as PopoverPrimitive from "@radix-ui/react-popover";
import { Icon } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./Popover.module.scss";

export interface PopoverContentComponentProps
  extends PopoverPrimitive.PopoverContentProps,
    React.RefAttributes<HTMLDivElement> {
  showCloseButton?: boolean;
  align?: "start" | "center" | "end";
  disablePortal?: boolean;
}

export const PopoverContent = React.forwardRef<
  HTMLDivElement,
  PopoverContentComponentProps
>(
  (
    {
      children,
      className,
      showCloseButton = true,
      align = "start",
      disablePortal,
      ...props
    },
    forwardedRef
  ) => {
    const styles = useUiStyles(CoreUiComponents.Popover, defaultStyles);
    const [block, cn] = useModuleBEM(styles, CoreUiComponents.Popover);

    const Portal =
      disablePortal != null && disablePortal
        ? Fragment
        : PopoverPrimitive.Portal;

    return (
      <Portal>
        <PopoverPrimitive.Content
          className={clsx(block, className)}
          align={align}
          {...props}
          ref={forwardedRef}
        >
          {children}
          {showCloseButton ? (
            <PopoverPrimitive.Close
              className={cn("close-button")}
              aria-label="Close"
            >
              <Icon iconName={IconNameEnum.close} />
            </PopoverPrimitive.Close>
          ) : null}
        </PopoverPrimitive.Content>
      </Portal>
    );
  }
);

export const Popover = PopoverPrimitive.Root;
export const PopoverTrigger = PopoverPrimitive.Trigger;
export const PopoverAnchor = PopoverPrimitive.Anchor;
